import { createWeb3Modal, defaultConfig } from "@web3modal/ethers/react"
import { message } from "antd"
import ReactDOM from "react-dom"

import App from "@/App"

import "@/styles/index.less"
import "@/styles/reset.less"

message.config({
    duration: 3,
    prefixCls: "rp_message",
    top: "5rem" as any
})

// 1. Get projectId
const projectId = 'cb82e7cd6f378cfaa44d7e5dd63744f5'

function getBlockchainApiRpcUrl(chainId: number) {
    return `https://rpc.walletconnect.org/v1/?chainId=eip155:${chainId}&projectId=${projectId}`
}

// 2. Set chains
const ethereumMainnet = {
    id: "eip155:1",
    chainId: 1,
    name: "Ethereum Mainnet",
    currency: "ETH",
    rpcUrl: getBlockchainApiRpcUrl(1),
    explorerUrl: "https://etherscan.io/",
    namespace: "eip155",
}
const sepoliaTestnet = {
    id: "eip155:11155111",
    chainId: 11155111,
    name: 'Sepolia Testnet',
    currency: "ETH",
    rpcUrl: getBlockchainApiRpcUrl(11155111),
    explorerUrl: "https://sepolia.etherscan.io/",
    namespace: "eip155",
}
const bscMainnet = {
    id: "eip155:56",
    chainId: 56,
    name: 'BNB Smart Chain Mainnet',
    currency: 'tBNB',
    explorerUrl: 'https://bscscan.com',
    rpcUrl: getBlockchainApiRpcUrl(3448148188),
    namespace: "eip155",
}
const bscTestnet = {
    id: "eip155:97",
    chainId: 97,
    name: 'BNB Smart Chain Testnet',
    currency: 'tBNB',
    rpcUrl: getBlockchainApiRpcUrl(97),
    explorerUrl: 'https://testnet.bscscan.com/',
    namespace: "eip155"
}
const tronNile = {
    id: "eip155:3448148188",
    chainId: 3448148188,
    name: "Tron Nile",
    currency: "TRX",
    rpcUrl: "https://api.nileex.io",
    explorerUrl: "https://nile.tronscan.org/"
}
const putMainnet = {
    chainId: -1,
    name: "Put Mainnet",
    currency: "PUT",
    rpcUrl: "https://rpc.put.com",
    explorerUrl: "https://putscan.com/"
}
const putTestnet = {
    chainId: -2,
    name: "Put Testnet",
    currency: "PUT",
    rpcUrl: "https://rpc-test.put.com",
    explorerUrl: "https://testnet.putscan.com/"
}
const zetaMainnet = {
    chainId: 7000,
    name: "ZetaChain",
    currency: "ZETA",
    rpcUrl: "https://zetachain-evm.blockpi.network/v1/rpc/public",
    explorerUrl: "https://explorer.zetachain.com/"
}
// const zetaTestnet = {
//     chainId: 7000,
//     name: "ZetaChain",
//     currency: "ZETA",
//     rpcUrl: "https://zetachain-evm.blockpi.network/v1/rpc/public",
//     explorerUrl: "https://explorer.zetachain.com/"
// }
// const tronNile = {
//     chainId: 3448148188,
//     name: "Tron Nile",
//     currency: "TRX",
//     rpcUrl: "",
//     exploreUrl: "",
// }
// 3. Create a metadata object
const metadata = {
    name: "ReelPay",
    description: "Provides safe and convenient cryptocurrency payment solutions with the goal of financializing cryptocurrency.",
    icons: ["https://reel-block-n.oss-ap-southeast-1.aliyuncs.com/base/202303/8ed0bf7c52c97a76.png"],
    url: window.location.host
}
// 4. Create Ethers config
const ethersConfig = defaultConfig({
    /*Required*/
    metadata,
    /*Optional*/
    // enableEIP6963: true, // true by default
    // enableInjected: true, // true by default
    // enableCoinbase: true, // true by default
    // rpcUrl: '...', // used for the Coinbase SDK
    // defaultChainId: 97, // used for the Coinbase SDK
    auth: {
        email: false,
        socials: [],
        showWallets: true,
        walletFeatures: false
    },
})

// 5. Create a AppKit instance
createWeb3Modal({
    ethersConfig,
    chains: [
        ethereumMainnet,
        sepoliaTestnet,
        bscMainnet,
        bscTestnet,
        zetaMainnet,
        tronNile,
        putMainnet,
        putTestnet
    ],
    featuredWalletIds: [
        "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96",
        "971e689d0a5be527bac79629b4ee9b925e82208e5168b733496a09c0faed0709",
        "8ff6eccefefa7506339201bc33346f92a43118d6ff7d6e71d499d8187a1c56a2",
        "4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0",
        "tronLink"
    ],
    projectId,
    themeMode: "light",
    enableAnalytics: false,// Optional - defaults to your Cloud configuration
    allowUnsupportedChain: true,
    // customWallets: [
    //     {
    //         id: 'tronLink',
    //         name: 'TronLink',
    //         homepage: 'https://www.tronlink.org', // Optional
    //         image_url: require("@/assets/tronlink.png"), // Optional
    //         // mobile_link: 'https://www.tronlink.org/dlDetails', // Optional - Deeplink or universal
    //         // desktop_link: 'https://www.tronlink.org/dlDetails', // Optional - Deeplink
    //         webapp_link: 'https://www.tronlink.org/dlDetails', // Optional
    //     }
    // ]
})

ReactDOM.render(
    <App />,
    document.getElementById("app")
)
